module.exports = __webpack_public_path__ + "static/img/banner-bighome.a1ad9ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bigHome/banner-bighome.jpg
// module id = b52r
// module chunks = 0